import React, { createContext, useContext, useEffect, useState } from "react";
import { RESTAURANTE_TAB, INFANTIL_TAB } from "@/data/cartaMenu";
import { UPDATED_MENU_TABS } from "@/data/menuAdditions";

const LANGS = ["es", "en", "va"];
const STORAGE_KEY = "ritual_lang";

export const translations = {
  langNames: { es: "ES", en: "EN", va: "VA" },

  nav: {
    home: { es: "Inicio", en: "Home", va: "Inici" },
    carta: { es: "Carta", en: "Menu", va: "Carta" },
    grupos: { es: "Grupos", en: "Groups", va: "Grups" },
    tienda: { es: "Tienda", en: "Shop", va: "Botiga" },
    locales: { es: "Locales", en: "Venues", va: "Locals" },
    finca: { es: "La Finca", en: "The Farm", va: "La Finca" },
    historia: { es: "Historia", en: "Our Story", va: "Història" },
    naguara: { es: "NAGUARÀ", en: "NAGUARÀ", va: "NAGUARÀ" },
    contacto: { es: "Contacto", en: "Contact", va: "Contacte" },
    reservar: { es: "Reservar", en: "Book a table", va: "Reservar" },
  },

  common: {
    discover: { es: "Descubrir más", en: "Discover more", va: "Descobrir més" },
    bookTable: { es: "Reservar Mesa", en: "Book a Table", va: "Reservar Taula" },
    viewMenu: { es: "Ver Carta", en: "View Menu", va: "Veure Carta" },
    shopNow: { es: "Ir a la Tienda", en: "Visit the Shop", va: "Anar a la Botiga" },
    addToCart: { es: "Añadir al carrito", en: "Add to cart", va: "Afegir al carret" },
    buy: { es: "Comprar", en: "Buy", va: "Comprar" },
    from: { es: "Desde", en: "From", va: "Des de" },
    call: { es: "Llamar", en: "Call", va: "Telefonar" },
    address: { es: "Dirección", en: "Address", va: "Adreça" },
    phone: { es: "Teléfono", en: "Phone", va: "Telèfon" },
    hours: { es: "Horario", en: "Hours", va: "Horari" },
    backToShop: { es: "Volver a la tienda", en: "Back to shop", va: "Tornar a la botiga" },
  },

  hero: {
    overline: { es: "Grupo Ritual · Valencia", en: "Grupo Ritual · Valencia", va: "Grup Ritual · València" },
    line1: { es: "Cada café cuenta una historia.", en: "Every coffee tells a story.", va: "Cada café conta una història." },
    line2: { es: "Cada mesa crea un recuerdo.", en: "Every table creates a memory.", va: "Cada taula crea un record." },
    subtitle: {
      es: "Desde el primer café de la mañana hasta la última copa de la noche, unimos gastronomía, café de especialidad y espacios diseñados para compartir momentos que merecen repetirse.",
      en: "From the first coffee of the morning to the last drink of the night, we bring together gastronomy, specialty coffee and spaces designed to share moments worth repeating.",
      va: "Des del primer café del matí fins a l'última copa de la nit, unim gastronomia, café d'especialitat i espais dissenyats per a compartir moments que mereixen repetir-se.",
    },
  },

  experience: {
    overline: { es: "La Experiencia Ritual", en: "The Ritual Experience", va: "L'Experiència Ritual" },
    title: { es: "Algo más que un café", en: "More than just coffee", va: "Quelcom més que un café" },
    intro: {
      es: "Restaurante y café de especialidad con el mismo protagonismo. Producto honesto, técnica y un origen que cuidamos desde la finca.",
      en: "Restaurant and specialty coffee with equal weight. Honest produce, technique and an origin we nurture from the farm.",
      va: "Restaurant i café d'especialitat amb el mateix protagonisme. Producte honest, tècnica i un origen que cuidem des de la finca.",
    },
    items: {
      coffee: { t: { es: "Specialty Coffee", en: "Specialty Coffee", va: "Specialty Coffee" }, d: { es: "Café de origen propio, tostado artesanal", en: "Single-origin coffee, artisan roasted", va: "Café d'origen propi, torrat artesanal" } },
      breakfast: { t: { es: "Desayunos", en: "Breakfast", va: "Esmorzars" }, d: { es: "Tostadas, pancakes, huevos benedict", en: "Toasts, pancakes, eggs benedict", va: "Torrades, pancakes, ous benedict" } },
      brunch: { t: { es: "Brunch", en: "Brunch", va: "Brunch" }, d: { es: "La forma perfecta de empezar el fin de semana", en: "The perfect way to start the weekend", va: "La manera perfecta de començar el cap de setmana" } },
      lunch: { t: { es: "Comidas", en: "Lunch", va: "Dinars" }, d: { es: "Cocina honesta, producto y técnica", en: "Honest cooking, produce and technique", va: "Cuina honesta, producte i tècnica" } },
      dinner: { t: { es: "Cenas", en: "Dinner", va: "Sopars" }, d: { es: "Entrecot, carrillera, pasta fresca", en: "Steak, beef cheek, fresh pasta", va: "Entrecot, galta, pasta fresca" } },
      wine: { t: { es: "Vinos", en: "Wines", va: "Vins" }, d: { es: "Selección de pequeños productores", en: "A selection of small producers", va: "Selecció de xicotets productors" } },
      cocktails: { t: { es: "Cócteles", en: "Cocktails", va: "Còctels" }, d: { es: "Coctelería de autor para la noche", en: "Signature cocktails for the night", va: "Coctelería d'autor per a la nit" } },
      spaces: { t: { es: "Espacios", en: "Spaces", va: "Espais" }, d: { es: "Diseñados para cada momento del día", en: "Designed for every moment of the day", va: "Dissenyats per a cada moment del dia" } },
    },
  },

  discover: {
    overline: { es: "Descubre Ritual", en: "Discover Ritual", va: "Descobreix Ritual" },
    finca: { t: { es: "La Finca", en: "The Farm", va: "La Finca" }, d: { es: "Nuestra plantación en Mérida, Venezuela, a 1800 m de altitud cultivando café de excelencia.", en: "Our plantation in Mérida, Venezuela, at 1800 m altitude growing coffee of excellence.", va: "La nostra plantació a Mérida, Veneçuela, a 1800 m d'altitud cultivant café d'excel·lència." } },
    historia: { t: { es: "Nuestra Historia", en: "Our Story", va: "La Nostra Història" }, d: { es: "De vender café por la ventana en pandemia a varios locales llenos de vida.", en: "From selling coffee through a window during the pandemic to several venues full of life.", va: "De vendre café per la finestra en pandèmia a diversos locals plens de vida." } },
    locales: { t: { es: "Nuestros Locales", en: "Our Venues", va: "Els Nostres Locals" }, d: { es: "Tres espacios únicos en Valencia: Valterna, Llíria y Rocafort.", en: "Three unique spaces in Valencia: Valterna, Llíria and Rocafort.", va: "Tres espais únics a València: Valterna, Llíria i Rocafort." } },
  },

  stats: {
    venues: { es: "Locales", en: "Venues", va: "Locals" },
    rating: { es: "Valoración", en: "Rating", va: "Valoració" },
    clients: { es: "Clientes", en: "Customers", va: "Clients" },
  },

  joinFamily: {
    title: { es: "Únete a la Familia Ritual", en: "Join the Ritual Family", va: "Uneix-te a la Família Ritual" },
    subtitle: {
      es: "Visítanos en cualquiera de nuestros locales o reserva tu mesa para una experiencia inolvidable.",
      en: "Visit us at any of our venues or book your table for an unforgettable experience.",
      va: "Visita'ns en qualsevol dels nostres locals o reserva la teua taula per a una experiència inoblidable.",
    },
  },

  shop: {
    overline: { es: "Tienda Ritual", en: "Ritual Shop", va: "Botiga Ritual" },
    title: { es: "Lleva Ritual a casa", en: "Take Ritual home", va: "Emporta't Ritual a casa" },
    intro: {
      es: "Café de origen propio, experiencias y regalos. Seguiremos ampliando el catálogo con nuevos cafés, accesorios y cursos.",
      en: "Single-origin coffee, experiences and gifts. We will keep expanding the catalogue with new coffees, accessories and courses.",
      va: "Café d'origen propi, experiències i regals. Continuarem ampliant el catàleg amb nous cafés, accessoris i cursos.",
    },
    weight: { es: "Formato", en: "Size", va: "Format" },
    grind: { es: "Molienda", en: "Grind", va: "Mòlta" },
    denomination: { es: "Importe", en: "Amount", va: "Import" },
    quantity: { es: "Cantidad", en: "Quantity", va: "Quantitat" },
    detail: { es: "Ver detalle", en: "View details", va: "Veure detall" },
    categories: {
      all: { es: "Todo", en: "All", va: "Tot" },
      cafe: { es: "Café", en: "Coffee", va: "Café" },
      cursos: { es: "Experiencias", en: "Experiences", va: "Experiències" },
      regalo: { es: "Regalo", en: "Gift", va: "Regal" },
    },
  },

  cart: {
    title: { es: "Tu carrito", en: "Your cart", va: "El teu carret" },
    empty: { es: "Tu carrito está vacío", en: "Your cart is empty", va: "El teu carret està buit" },
    emptyCta: { es: "Explora la tienda y añade tus favoritos.", en: "Explore the shop and add your favourites.", va: "Explora la botiga i afig els teus favorits." },
    subtotal: { es: "Subtotal", en: "Subtotal", va: "Subtotal" },
    checkout: { es: "Finalizar compra", en: "Checkout", va: "Finalitzar compra" },
    processing: { es: "Redirigiendo a pago seguro…", en: "Redirecting to secure payment…", va: "Redirigint a pagament segur…" },
    remove: { es: "Quitar", en: "Remove", va: "Llevar" },
    note: { es: "Pago seguro con Stripe. Impuestos incluidos.", en: "Secure payment with Stripe. Taxes included.", va: "Pagament segur amb Stripe. Impostos inclosos." },
  },

  gracias: {
    badge: { es: "Pedido confirmado", en: "Order confirmed", va: "Comanda confirmada" },
    title: { es: "¡Gracias por tu compra!", en: "Thank you for your purchase!", va: "Gràcies per la teua compra!" },
    subtitle: {
      es: "Hemos recibido tu pedido correctamente. Recibirás todos los detalles muy pronto. Gracias por formar parte de la familia Ritual.",
      en: "We have successfully received your order. You will receive all the details very soon. Thank you for being part of the Ritual family.",
      va: "Hem rebut la teua comanda correctament. Rebràs tots els detalls molt prompte. Gràcies per formar part de la família Ritual.",
    },
    orderSummary: { es: "Resumen del pedido", en: "Order summary", va: "Resum de la comanda" },
    total: { es: "Total", en: "Total", va: "Total" },
    keepShopping: { es: "Seguir comprando", en: "Keep shopping", va: "Continuar comprant" },
    discoverNaguara: { es: "Conoce NAGUARÀ", en: "Discover NAGUARÀ", va: "Coneix NAGUARÀ" },
    follow: { es: "Síguenos en Instagram", en: "Follow us on Instagram", va: "Segueix-nos a Instagram" },
    checking: { es: "Confirmando tu pago…", en: "Confirming your payment…", va: "Confirmant el teu pagament…" },
    error: { es: "No hemos podido confirmar el pago. Si el problema persiste, contáctanos.", en: "We could not confirm the payment. If the problem persists, contact us.", va: "No hem pogut confirmar el pagament. Si el problema persisteix, contacta'ns." },
    timeout: { es: "La confirmación está tardando más de lo normal. Revisa tu correo o vuelve a intentarlo.", en: "Confirmation is taking longer than usual. Check your email or try again.", va: "La confirmació està tardant més del normal. Revisa el teu correu o torna-ho a intentar." },
  },

  reservas: {
    overline: { es: "Reservas", en: "Reservations", va: "Reserves" },
    title: { es: "Reserva tu mesa", en: "Book your table", va: "Reserva la teua taula" },
    selectVenue: { es: "Selecciona tu local favorito", en: "Choose your favourite venue", va: "Tria el teu local favorit" },
    coverManagerNote: {
      es: "Reserva online en tiempo real a través de nuestro sistema de reservas.",
      en: "Book online in real time through our reservation system.",
      va: "Reserva en línia en temps real a través del nostre sistema de reserves.",
    },
    bookOnline: { es: "Reservar online", en: "Book online", va: "Reservar en línia" },
    callToBook: { es: "Llámanos para reservar", en: "Call us to book", va: "Telefona'ns per a reservar" },
    // Llíria WhatsApp form
    lliriaTitle: { es: "Reserva en Ritual Llíria", en: "Book at Ritual Llíria", va: "Reserva a Ritual Llíria" },
    lliriaSubtitle: {
      es: "Completa tus datos y te atenderemos por WhatsApp.",
      en: "Fill in your details and we will assist you via WhatsApp.",
      va: "Emplena les teues dades i t'atendrem per WhatsApp.",
    },
    name: { es: "Nombre", en: "Name", va: "Nom" },
    phoneField: { es: "Teléfono", en: "Phone", va: "Telèfon" },
    date: { es: "Fecha", en: "Date", va: "Data" },
    time: { es: "Hora", en: "Time", va: "Hora" },
    people: { es: "Personas", en: "Guests", va: "Persones" },
    comments: { es: "Comentarios (opcional)", en: "Comments (optional)", va: "Comentaris (opcional)" },
    submit: { es: "Reservar por WhatsApp", en: "Book via WhatsApp", va: "Reservar per WhatsApp" },
    required: { es: "Por favor completa todos los campos obligatorios.", en: "Please complete all required fields.", va: "Per favor, emplena tots els camps obligatoris." },
    confirmTitle: { es: "Abriendo WhatsApp", en: "Opening WhatsApp", va: "Obrint WhatsApp" },
    confirmBody: {
      es: "Se abrirá WhatsApp para completar tu reserva. Nuestro equipo confirmará la disponibilidad lo antes posible. Tu reserva no queda confirmada automáticamente.",
      en: "WhatsApp will open to complete your booking. Our team will confirm availability as soon as possible. Your booking is not confirmed automatically.",
      va: "S'obrirà WhatsApp per a completar la teua reserva. El nostre equip confirmarà la disponibilitat com més prompte millor. La teua reserva no queda confirmada automàticament.",
    },
    waMessage: {
      es: "Hola, me gustaría hacer una reserva en Ritual Llíria.",
      en: "Hola, me gustaría hacer una reserva en Ritual Llíria.",
      va: "Hola, me gustaría hacer una reserva en Ritual Llíria.",
    },
  },

  finca: {
    overline: { es: "Nuestra Finca", en: "Our Farm", va: "La Nostra Finca" },
    title: { es: "Mérida, Venezuela — Los Andes", en: "Mérida, Venezuela — The Andes", va: "Mérida, Veneçuela — Els Andes" },
    elevation: { es: "Elevación", en: "Elevation", va: "Elevació" },
    plantation: { es: "Nuestra Plantación", en: "Our Plantation", va: "La Nostra Plantació" },
    growing: { es: "En Crecimiento", en: "Growing", va: "En Creixement" },
    temp: { es: "Temperatura", en: "Temperature", va: "Temperatura" },
    bodyTitle: { es: "Nuestro Destino en los Andes", en: "Our Destiny in the Andes", va: "El Nostre Destí als Andes" },
    body1: {
      es: "Trabajamos nuestras tierras a 1800 metros sobre el nivel del mar, en una montaña de los Andes donde el clima perfecto y la altura ideal proyectan un café de excelencia.",
      en: "We work our land at 1800 metres above sea level, on a mountain in the Andes where the perfect climate and ideal altitude produce coffee of excellence.",
      va: "Treballem les nostres terres a 1800 metres sobre el nivell del mar, en una muntanya dels Andes on el clima perfecte i l'altura ideal projecten un café d'excel·lència.",
    },
    body2: {
      es: "Nuestra familia, con vasta experiencia durante generaciones, gestiona el trabajo diario en la finca. Generamos empleo y oportunidades para la comunidad, especialmente para las mujeres del pueblo.",
      en: "Our family, with vast experience across generations, manages the daily work on the farm. We create jobs and opportunities for the community, especially for the women of the town.",
      va: "La nostra família, amb vasta experiència durant generacions, gestiona el treball diari a la finca. Generem ocupació i oportunitats per a la comunitat, especialment per a les dones del poble.",
    },
    variety: { es: "Variedad", en: "Variety", va: "Varietat" },
    process: { es: "Proceso", en: "Process", va: "Procés" },
  },

  historia: {
    overline: { es: "Nuestra Historia", en: "Our Story", va: "La Nostra Història" },
    title: { es: "De la pandemia a varios locales llenos de vida", en: "From the pandemic to several venues full of life", va: "De la pandèmia a diversos locals plens de vida" },
    quote: {
      es: "El café no es solo una bebida, es un punto de encuentro, un respiro, un ritual diario que conecta a las personas.",
      en: "Coffee is not just a drink, it is a meeting point, a breath, a daily ritual that connects people.",
      va: "El café no és només una beguda, és un punt de trobada, un respir, un ritual diari que connecta les persones.",
    },
    p1: {
      es: "Ritual no nació en un despacho cómodo, nació en un momento difícil. Abrimos nuestro primer local, Ritual Café Valterna, y a los dos días el mundo se paró. Era plena pandemia y tuvimos que cerrar… pero en lugar de rendirnos, abrimos la ventana. Literalmente.",
      en: "Ritual was not born in a comfortable office, it was born in a difficult moment. We opened our first venue, Ritual Café Valterna, and two days later the world stopped. It was the height of the pandemic and we had to close… but instead of giving up, we opened the window. Literally.",
      va: "Ritual no va nàixer en un despatx còmode, va nàixer en un moment difícil. Vam obrir el nostre primer local, Ritual Café Valterna, i als dos dies el món es va parar. Era plena pandèmia i vam haver de tancar… però en lloc de rendir-nos, vam obrir la finestra. Literalment.",
    },
    p2: {
      es: "Empezamos a vender café por la ventana a los vecinos, uno a uno, creando pequeños momentos de normalidad. Lo que empezó con una ventana fue creciendo: llegó Llíria, después Rocafort, y Ritual dejó de ser un local para convertirse en una forma de hacer las cosas.",
      en: "We started selling coffee through the window to our neighbours, one by one, creating small moments of normality. What began with a window kept growing: Llíria came, then Rocafort, and Ritual stopped being a venue to become a way of doing things.",
      va: "Vam començar a vendre café per la finestra als veïns, un a un, creant xicotets moments de normalitat. El que va començar amb una finestra va anar creixent: va arribar Llíria, després Rocafort, i Ritual va deixar de ser un local per a convertir-se en una manera de fer les coses.",
    },
    teamTitle: { es: "Nuestro Equipo", en: "Our Team", va: "El Nostre Equip" },
    noel: { t: { es: "Noel — Nuestra Finca", en: "Noel — Our Farm", va: "Noel — La Nostra Finca" }, d: { es: "Cuida con dedicación nuestra plantación de café en Mérida, Venezuela, a 1800 m, asegurando el cuidado artesanal que distingue a Ritual.", en: "He devotedly tends our coffee plantation in Mérida, Venezuela, at 1800 m, ensuring the artisan care that defines Ritual.", va: "Cuida amb dedicació la nostra plantació de café a Mérida, Veneçuela, a 1800 m, assegurant la cura artesanal que distingeix Ritual." } },
    jagtar: { t: { es: "Jagtar — Chef Ejecutivo", en: "Jagtar — Executive Chef", va: "Jagtar — Chef Executiu" }, d: { es: "Lidera la cocina en nuestros restaurantes, combinando sabores auténticos con técnicas innovadoras en cada plato.", en: "He leads the kitchen across our restaurants, combining authentic flavours with innovative techniques in every dish.", va: "Lidera la cuina als nostres restaurants, combinant sabors autèntics amb tècniques innovadores en cada plat." } },
  },

  locales: {
    overline: { es: "Nuestros Locales", en: "Our Venues", va: "Els Nostres Locals" },
    title: { es: "Tres espacios únicos en Valencia", en: "Three unique spaces in Valencia", va: "Tres espais únics a València" },
    directions: { es: "Cómo llegar", en: "Get directions", va: "Com arribar" },
    list: [
      {
        id: "valterna",
        name: "Ritual Café Valterna",
        area: { es: "Paterna, Valencia", en: "Paterna, Valencia", va: "Paterna, València" },
        desc: { es: "Nuestro primer local. Donde comenzó la historia de Grupo Ritual y aprendimos que el café conecta personas.", en: "Our first venue. Where the story of Grupo Ritual began and we learned that coffee connects people.", va: "El nostre primer local. On va començar la història del Grup Ritual i vam aprendre que el café connecta persones." },
        address: "Carrer Ravanell, 1, 46980 Paterna, Valencia",
        phone: "+34 960 41 98 55",
        hours: { es: "Lun, Mié-Dom: 9:00-23:00 · Martes: Cerrado", en: "Mon, Wed-Sun: 9:00-23:00 · Tuesday: Closed", va: "Dl, Dc-Dg: 9:00-23:00 · Dimarts: Tancat" },
      },
      {
        id: "lliria",
        name: "Ritual Café Llíria",
        area: { es: "Llíria, Valencia", en: "Llíria, Valencia", va: "Llíria, València" },
        desc: { es: "Nuestro segundo hogar, donde el amor por el café crece cada día en el corazón de Llíria.", en: "Our second home, where the love for coffee grows every day in the heart of Llíria.", va: "La nostra segona casa, on l'amor pel café creix cada dia al cor de Llíria." },
        address: "Calle Llibertat, 9, 46160 Llíria, Valencia",
        phone: "+34 960 52 46 47",
        hours: { es: "Lun, Mié-Dom: 9:00-23:00 · Martes: Cerrado", en: "Mon, Wed-Sun: 9:00-23:00 · Tuesday: Closed", va: "Dl, Dc-Dg: 9:00-23:00 · Dimarts: Tancat" },
      },
      {
        id: "rocafort",
        name: "Ritual Café Rocafort",
        area: { es: "Rocafort, Valencia", en: "Rocafort, Valencia", va: "Rocafort, València" },
        desc: { es: "El más reciente de nuestros espacios. Un rincón donde vivir el café con alma y autenticidad.", en: "The newest of our spaces. A corner to experience coffee with soul and authenticity.", va: "El més recent dels nostres espais. Un racó on viure el café amb ànima i autenticitat." },
        address: "Calle Burjassot, 1, 46111 Rocafort, Valencia",
        phone: "+34 961 07 69 25",
        hours: { es: "Lun, Mié-Dom: 9:00-23:00 · Martes: Cerrado", en: "Mon, Wed-Sun: 9:00-23:00 · Tuesday: Closed", va: "Dl, Dc-Dg: 9:00-23:00 · Dimarts: Tancat" },
      },
    ],
  },

  carta: {
    overline: { es: "Ritual Café", en: "Ritual Café", va: "Ritual Café" },
    title: { es: "Nuestra Carta", en: "Our Menu", va: "La Nostra Carta" },
    subtitle: { es: "Cocina honesta, producto y técnica", en: "Honest cooking, produce and technique", va: "Cuina honesta, producte i tècnica" },
    allergenTitle: { es: "Alérgenos", en: "Allergens", va: "Al·lèrgens" },
    allergenNote: {
      es: "Indicamos los alérgenos de cada plato según la normativa europea. Si tienes alguna alergia o intolerancia, coméntalo a nuestro personal.",
      en: "We label the allergens of each dish according to EU regulations. If you have any allergy or intolerance, please tell our staff.",
      va: "Indiquem els al·lèrgens de cada plat segons la normativa europea. Si tens alguna al·lèrgia o intolerància, comenta-ho al nostre personal.",
    },
    allergenAsk: { es: "Consultar alérgenos con el personal de sala", en: "Ask our floor staff about allergens", va: "Consulta els al·lèrgens amb el personal de sala" },
    allergenNone: { es: "Sin alérgenos declarados", en: "No allergens declared", va: "Sense al·lèrgens declarats" },
    allergens: {
      gluten: { es: "Gluten", en: "Gluten", va: "Gluten" },
      lacteos: { es: "Lácteos", en: "Dairy", va: "Lactis" },
      huevos: { es: "Huevos", en: "Eggs", va: "Ous" },
      pescado: { es: "Pescado", en: "Fish", va: "Peix" },
      moluscos: { es: "Moluscos", en: "Molluscs", va: "Mol·luscos" },
      soja: { es: "Soja", en: "Soy", va: "Soja" },
      mostaza: { es: "Mostaza", en: "Mustard", va: "Mostassa" },
      apio: { es: "Apio", en: "Celery", va: "Api" },
      sulfitos: { es: "Sulfitos", en: "Sulphites", va: "Sulfits" },
      frutoscascara: { es: "Frutos de cáscara", en: "Tree nuts", va: "Fruits de clofolla" },
      crustaceos: { es: "Crustáceos", en: "Crustaceans", va: "Crustacis" },
      cacahuetes: { es: "Cacahuetes", en: "Peanuts", va: "Cacauets" },
      sesamo: { es: "Sésamo", en: "Sesame", va: "Sèsam" },
      altramuces: { es: "Altramuces", en: "Lupin", va: "Tramussos" },
    },
    tabs: [
      {
        key: "desayunos",
        label: { es: "Desayunos", en: "Breakfast", va: "Esmorzars" },
        sections: [
          {
            title: { es: "Tostadas Especiales", en: "Special Toasts", va: "Torrades Especials" },
            items: [
              { n: { es: "Ritual", en: "Ritual", va: "Ritual" }, d: { es: "Revuelto, aguacate y jamón", en: "Scrambled eggs, avocado and ham", va: "Remenat, alvocat i pernil" }, p: "5,20€", a: ["gluten", "huevos"] },
              { n: { es: "Salmón", en: "Salmon", va: "Salmó" }, d: { es: "Revuelto, aguacate y salmón", en: "Scrambled eggs, avocado and salmon", va: "Remenat, alvocat i salmó" }, p: "6,50€", a: ["huevos", "pescado", "sulfitos", "gluten"] },
              { n: { es: "Italiana", en: "Italian", va: "Italiana" }, d: { es: "Cherrys, pesto y stracciatella", en: "Cherry tomatoes, pesto and stracciatella", va: "Cherrys, pesto i stracciatella" }, p: "5,80€", a: ["lacteos", "gluten", "frutoscascara"] },
              { n: { es: "Tostada de temporada", en: "Seasonal Toast", va: "Torrada de temporada" }, d: { es: "Preguntar al personal de sala", en: "Ask our floor staff", va: "Pregunta al personal de sala" }, p: "", a: [] },
              { n: { es: "Pancakes", en: "Pancakes", va: "Pancakes" }, d: { es: "Dulces o salados", en: "Sweet or savoury", va: "Dolços o salats" }, p: "9,00€", a: ["huevos", "lacteos", "gluten"] },
              { n: { es: "Huevos Benedict", en: "Eggs Benedict", va: "Ous Benedict" }, d: { es: "", en: "", va: "" }, p: "9,50€", a: ["huevos", "lacteos", "gluten"] },
            ],
          },
          {
            title: { es: "Suplementos", en: "Add-ons", va: "Suplements" },
            items: [
              { n: { es: "Aguacate", en: "Avocado", va: "Alvocat" }, d: { es: "", en: "", va: "" }, p: "2,00€", a: [] },
              { n: { es: "Huevo revuelto", en: "Scrambled Egg", va: "Ou remenat" }, d: { es: "", en: "", va: "" }, p: "2,00€", a: ["huevos"] },
              { n: { es: "Huevo poché", en: "Poached Egg", va: "Ou poché" }, d: { es: "", en: "", va: "" }, p: "2,00€", a: ["huevos"] },
              { n: { es: "Jamón serrano", en: "Serrano Ham", va: "Pernil serrà" }, d: { es: "", en: "", va: "" }, p: "2,50€", a: [] },
              { n: { es: "Burrata", en: "Burrata", va: "Burrata" }, d: { es: "", en: "", va: "" }, p: "3,50€", a: ["lacteos"] },
            ],
          },
        ],
      },
      {
        key: "almuerzos",
        label: { es: "Almuerzos", en: "Brunch / Lunch", va: "Almorzars" },
        sections: [
          {
            title: { es: "Almuerzos", en: "Brunch / Lunch", va: "Almorzars" },
            note: { es: "Medio almuerzo 7,50€ · Almuerzo 8,00€ — elige tu bocata", en: "Half 7.50€ · Full 8.00€ — choose your sandwich", va: "Mig almorzar 7,50€ · Almorzar 8,00€ — tria el teu entrepà" },
            items: [
              { n: { es: "Tortilla de patatas con longanizas", en: "Potato Omelette with Longaniza", va: "Truita de creïlles amb llonganisses" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos"] },
              { n: { es: "Francesa con jamón", en: "French Omelette with Ham", va: "Francesa amb pernil" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos"] },
              { n: { es: "Sobrasada con queso", en: "Sobrasada with Cheese", va: "Sobrassada amb formatge" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "lacteos"] },
              { n: { es: "Pechuga de pollo", en: "Chicken Breast", va: "Pit de pollastre" }, d: { es: "Con lechuga, tomate y mayonesa", en: "With lettuce, tomato and mayonnaise", va: "Amb lletuga, tomaca i maionesa" }, p: "", a: ["gluten", "huevos"] },
              { n: { es: "Lomo con queso", en: "Pork Loin with Cheese", va: "Llom amb formatge" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "lacteos"] },
              { n: { es: "Tortilla de patata", en: "Potato Omelette", va: "Truita de creïlla" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos"] },
            ],
          },
          {
            title: { es: "Almuerzos Especiales", en: "Special Brunch / Lunch", va: "Almorzars Especials" },
            note: { es: "Almuerzo especial 9,00€ · No incluye cafés especiales — elige tu bocata", en: "Special 9.00€ · Specialty coffees not included — choose your sandwich", va: "Almorzar especial 9,00€ · No inclou cafés especials — tria el teu entrepà" },
            items: [
              { n: { es: "Costillas de cerdo", en: "Pork Ribs", va: "Costelles de porc" }, d: { es: "Con patatas, tomate, mostaza y mayonesa", en: "With potatoes, tomato, mustard and mayonnaise", va: "Amb creïlles, tomaca, mostassa i maionesa" }, p: "", a: ["gluten", "huevos", "mostaza"] },
              { n: { es: "Secreto ibérico con ajos tiernos", en: "Iberian Secreto with Spring Garlic", va: "Secret ibèric amb alls tendres" }, d: { es: "Con patatas mayonesa hoisin, mostaza y huevo", en: "With potatoes, hoisin mayo, mustard and egg", va: "Amb creïlles, maionesa hoisin, mostassa i ou" }, p: "", a: ["gluten", "huevos", "mostaza", "soja"] },
              { n: { es: "Revuelto de boletus y trufa", en: "Boletus and Truffle Scramble", va: "Remenat de bolets i tòfona" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos"] },
              { n: { es: "Chivito", en: "Chivito", va: "Chivito" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos", "lacteos"] },
              { n: { es: "Chivito de pollo trufado", en: "Truffled Chicken Chivito", va: "Chivito de pollastre tofonat" }, d: { es: "", en: "", va: "" }, p: "", a: ["gluten", "huevos", "lacteos"] },
              { n: { es: "Calamares", en: "Squid", va: "Calamars" }, d: { es: "Con alioli o mayonesa", en: "With aioli or mayonnaise", va: "Amb allioli o maionesa" }, p: "", a: ["gluten", "moluscos", "huevos"] },
            ],
          },
        ],
      },
      {
        key: "bebidas",
        label: { es: "Bebidas", en: "Drinks", va: "Begudes" },
        sections: [{ title: { es: "Bebidas", en: "Drinks", va: "Begudes" }, note: { es: "Consulta nuestra selección de refrescos, zumos naturales e infusiones con el equipo de sala.", en: "Ask our floor team about our soft drinks, fresh juices and infusions.", va: "Consulta la nostra selecció de refrescos, sucs naturals i infusions amb l'equip de sala." }, items: [] }],
      },
      {
        key: "cafes",
        label: { es: "Cafés", en: "Coffee", va: "Cafés" },
        sections: [{ title: { es: "Cafés de Especialidad", en: "Specialty Coffee", va: "Cafés d'Especialitat" }, note: { es: "Nuestro café de especialidad NAGUARÀ, de origen propio: espresso, cortado, flat white, filtrados V60 y más. Pregúntanos por el café del día.", en: "Our single-origin NAGUARÀ specialty coffee: espresso, cortado, flat white, V60 pour-overs and more. Ask us for the coffee of the day.", va: "El nostre café d'especialitat NAGUARÀ, d'origen propi: espresso, tallat, flat white, filtrats V60 i més. Pregunta'ns pel café del dia." }, items: [] }],
      },
      {
        key: "vinos",
        label: { es: "Vinos", en: "Wines", va: "Vins" },
        sections: [{ title: { es: "Vinos", en: "Wines", va: "Vins" }, note: { es: "Selección de vinos de pequeños productores. Consulta nuestra carta de vinos en el restaurante.", en: "A selection of wines from small producers. Ask for our wine list at the restaurant.", va: "Selecció de vins de xicotets productors. Consulta la nostra carta de vins al restaurant." }, items: [] }],
      },
      {
        key: "cocteles",
        label: { es: "Cócteles", en: "Cocktails", va: "Còctels" },
        sections: [{ title: { es: "Cócteles de Autor", en: "Signature Cocktails", va: "Còctels d'Autor" }, note: { es: "Coctelería de autor para la noche. Consulta nuestra carta de cócteles con el equipo de sala.", en: "Signature cocktails for the night. Ask our floor team for our cocktail list.", va: "Coctelería d'autor per a la nit. Consulta la nostra carta de còctels amb l'equip de sala." }, items: [] }],
      },
    ],
  },

  footer: {
    tagline: { es: "Good Food. Specialty Coffee. Great Moments.", en: "Good Food. Specialty Coffee. Great Moments.", va: "Good Food. Specialty Coffee. Great Moments." },
    description: {
      es: "Restaurante y café de especialidad en Valencia. Café de origen propio, gastronomía honesta y espacios para compartir.",
      en: "Restaurant and specialty coffee in Valencia. Single-origin coffee, honest food and spaces to share.",
      va: "Restaurant i café d'especialitat a València. Café d'origen propi, gastronomia honesta i espais per a compartir.",
    },
    explore: { es: "Explora", en: "Explore", va: "Explora" },
    brands: { es: "Marcas", en: "Brands", va: "Marques" },
    follow: { es: "Síguenos", en: "Follow us", va: "Segueix-nos" },
    contactTitle: { es: "Contacto", en: "Contact", va: "Contacte" },
    newsletterTitle: { es: "Newsletter", en: "Newsletter", va: "Newsletter" },
    newsletterSub: {
      es: "Novedades, lanzamientos y café del bueno en tu correo.",
      en: "News, launches and great coffee in your inbox.",
      va: "Novetats, llançaments i café del bo al teu correu.",
    },
    naguara: { es: "NAGUARÀ Cafés", en: "NAGUARÀ Cafés", va: "NAGUARÀ Cafés" },
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved.", va: "Tots els drets reservats." },
  },
};

// BLOQUE A — Composición de las pestañas de Carta desde las fuentes JSON versionadas.
// Se reemplaza `restaurante` (contenido 2026), se ELIMINA `postres` (sus 2 tartas se absorben en
// "Un cachito de tarta" dentro de Restaurante) y se INSERTA `infantil` tras Restaurante.
// Reconstrucción 100% POR CLAVE (orden explícito, sin depender de índices numéricos). Desayunos,
// Bebidas se conserva; desayunos/almuerzos/cafés/vinos usan el nuevo impreso sin inferir alérgenos.
(() => {
  const byKey = Object.fromEntries(translations.carta.tabs.map((t) => [t.key, t]));
  const OVERRIDES = { restaurante: RESTAURANTE_TAB, infantil: INFANTIL_TAB, ...UPDATED_MENU_TABS };
  const ORDER = ["desayunos", "almuerzos", "restaurante", "infantil", "bebidas", "cafes", "vinos"];
  translations.carta.tabs = ORDER.map((k) => OVERRIDES[k] || byKey[k]).filter(Boolean);
})();

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return LANGS.includes(saved) ? saved : "es";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (node) => {
    if (node == null) return "";
    if (typeof node === "string") return node;
    return node[lang] ?? node.es ?? "";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}

export function formatEUR(value) {
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(value);
}
